import { RESPONSE_FOR_MAPPED_COMPANYNAME, RESPONSE_FOR_COMPANYNAME_SEARCH, RESPONSE_SAVE_MAPPED_COMPANIES_SUCCESS, RESPONSE_SAVE_MAPPED_COMPANIES_FAILURE } from './action';

const initialState = {
    companyNameOnAgency: {},
    companyNameList: {},
    saveMappedCompanySuccess: {},
    saveMappedCompanyFailure: {}
}

const ratingCompanyMap = (state = initialState, action) => {
    switch (action.type) {
        case RESPONSE_FOR_MAPPED_COMPANYNAME:
            return state = {
                ...state,
                companyNameOnAgency: action.data
            }

        case RESPONSE_FOR_COMPANYNAME_SEARCH:
            return state = {
                ...state,
                companyNameList: action.data
            }

        case RESPONSE_SAVE_MAPPED_COMPANIES_SUCCESS:
            return state = {
                ...state,
                saveMappedCompanySuccess: action.data.data,
                companyNameOnAgency: action.data.requestBody,
                companyNameList: {}
            }
            
        case RESPONSE_SAVE_MAPPED_COMPANIES_FAILURE:
            return state = {
                ...state,
                saveMappedCompanyFailure: action.data
            }

        default: return state
    }
}
export default ratingCompanyMap;